import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Location = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3637 21.7554C23.8152 19.5015 26 17.4929 26 12.8C26 7.38761 21.5228 3 16 3C10.4772 3 6 7.38761 6 12.8C6 17.4929 8.18481 19.5015 10.6363 21.7554C12.573 23.5359 14.676 25.4694 16 29C17.324 25.4694 19.427 23.5359 21.3637 21.7554ZM16 17C18.2091 17 20 15.2091 20 13C20 10.7909 18.2091 9 16 9C13.7909 9 12 10.7909 12 13C12 15.2091 13.7909 17 16 17Z"
        fill={color}
      />
    </svg>
  );
};

export default Location;
